var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card folders-container" }, [
    _c("div", { staticClass: "card-content px-0 pt-2 pb-3" }, [
      _c("div", { staticClass: "row-folder-header is-clearfix" }, [
        _c(
          "a",
          {
            staticClass: "is-size-7 is-pulled-left",
            on: { click: _vm.toPreviousFolder },
          },
          [
            _c("i", { staticClass: "fas fa-reply fa-fw" }),
            _vm._v(" Volver atrás"),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "is-size-7 is-pulled-right",
            on: { click: _vm.showDialogNewFolder },
          },
          [
            _c("i", { staticClass: "fas fa-folder-plus fa-fw" }),
            _vm._v(" Nueva carpeta"),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "folder-rows-container" },
        [
          _vm._l(_vm.routes, function (route, index) {
            return _c(
              "div",
              {
                key: `folder-route-${index}`,
                staticClass: "row-folder",
                class: {
                  selected:
                    _vm.selectedFolder != null &&
                    _vm.selectedFolder.nombre == _vm.currentFolder.nombre &&
                    index == _vm.routes.length - 1,
                },
                style: { paddingLeft: `${20 + 12 * index}px` },
                on: {
                  click: function ($event) {
                    if (
                      $event.ctrlKey ||
                      $event.shiftKey ||
                      $event.altKey ||
                      $event.metaKey
                    )
                      return null
                    return _vm.selectPreviousFolder(index)
                  },
                  dblclick: function ($event) {
                    _vm.dobleClickPreviousFolders(
                      _vm.routes.slice(0, index + 1).join("/")
                    )
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "far fa-fw fa-lg",
                  class: {
                    "fa-folder-open": index > 0,
                    "fa-building": index == 0,
                  },
                }),
                _vm._v("  "),
                _c("b", [_vm._v(_vm._s(route))]),
              ]
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.folders, function (folder, indexFolder) {
            return _c(
              "div",
              {
                key: `folder-${indexFolder}-${folder.id}`,
                staticClass: "row-folder",
                class: {
                  selected:
                    _vm.selectedFolder != null &&
                    folder.id == _vm.selectedFolder.id,
                },
                style: { paddingLeft: `${20 + 12 * _vm.routes.length}px` },
                on: {
                  click: function ($event) {
                    if (
                      $event.ctrlKey ||
                      $event.shiftKey ||
                      $event.altKey ||
                      $event.metaKey
                    )
                      return null
                    return _vm.selectOneFolder(folder, indexFolder)
                  },
                  dblclick: function ($event) {
                    return _vm.dobleClick(folder)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa-fw fa-lg",
                  class: _vm.getIconFile(folder.tipo_documento_id),
                }),
                _vm._v("  " + _vm._s(folder.nombre) + "\n\n    "),
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "infinite-loading",
            {
              attrs: { identifier: _vm.identifierLoaderFolders },
              on: { infinite: _vm.infiniteHandlerFolders },
            },
            [
              _c("span", { attrs: { slot: "no-more" }, slot: "no-more" }),
              _vm._v(" "),
              _c("span", { attrs: { slot: "no-results" }, slot: "no-results" }),
            ]
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }